/**
 * Carousel.jsx
 * Created by michaelbray on 2/23/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    images: PropTypes.array,
    displayThumbnail: PropTypes.bool
};

export default class Carousel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            imageIndex: 0
        };

        this.navigateNext = this.navigateNext.bind(this);
        this.navigatePrev = this.navigatePrev.bind(this);
        this.renderImage = this.renderImage.bind(this);
    }

    navigateNext() {
        const nextIndex = this.state.imageIndex + 1;

        if (nextIndex < this.props.images.length) {
            this.setState({
                imageIndex: nextIndex
            });
        }
    }

    navigatePrev() {
        const prevIndex = this.state.imageIndex - 1;

        if (prevIndex >= 0) {
            this.setState({
                imageIndex: prevIndex
            });
        }
    }

    renderImage() {
        const imgSrc = this.props.images[this.state.imageIndex].url;

        return (
            <img
                className="rec-carousel-current-image"
                src={imgSrc}
                alt="Current"
                role="presentation" />
        );
    }

    render() {
        const imagelist = this.props.images;
        const displayThumbnail = (this.props.displayThumbnail === true);

        if (imagelist && imagelist.length > 0) {
            return (
                <div className="rec-carousel">
                    <div className="rec-carousel-slide">
                        {this.renderImage()}
                    </div>
                    {imagelist.length > 1 &&
                        <button
                            type="button"
                            onClick={this.navigatePrev}
                            className="rec-carousel-arrow rec-carousel-prev"
                            alt="Previous">
                            Previous
                        </button>
                    }

                    {imagelist.length > 1 && displayThumbnail &&
                    <div className="rec-carousel-track">
                        <ul id="rec-carousel-track-list">
                            {imagelist.map((image, index) => {
                                return (
                                    <li
                                        className="rec-carousel-thumbnail"
                                        key={`img-${index}`}>
                                        <img
                                            src={image.url}
                                            alt={image.title} />
                                    </li>
                                );
                            })
                            }
                        </ul>
                    </div>}
                    {imagelist.length > 1 &&
                        <button
                            type="button"
                            onClick={this.navigateNext}
                            className="rec-carousel-arrow rec-carousel-next"
                            aria-label="Previous">
                            Next
                        </button>
                    }
                </div>
            );
        }

        return (<div className="rec-carousel-empty" />);
    }
}

Carousel.propTypes = propTypes;
